export const types = {
   login: '[Auth] Login',
   logout: '[Auth] Logout',

   uiSetError: '[UI] Set Error',
   uiRemoveError: '[UI] Remove Error',

   uiStartLoading: '[UI] Start Loading',
   uiStopLoading: '[UI] Stop Loading',

   notesAddNew: '[Notes] New Note',
   notesActive: '[Notes] Set Active Note',
   notesLoad: '[Notes] Charge Notes',
   notesUpdated: '[Notes] Updated Note',
   notesFileUrl: '[Notes] Update Image Note',
   notesDeleted: '[Notes] Delete Note',
   notesLogoutCleaning: '[Notes] Logout Cleaning',
}